import React from 'react';
import {render} from 'react-dom';
import root from 'window-or-global';
import {EpicGamesFooter} from 'epic-games-footer';
import addObserverCallback from 'epic-games-footer/dist/observe/epicGamesFooterObserver';
import {EpicGamesFooterProps} from 'epic-games-footer';
import {
  EmbeddedNavLinkComponent,
  EmbeddedProvider,
} from 'epic-fortnite-react/components/mainNav/EmbeddedNavLinkComponent';

// renderFooter is only used for the standalone footer
const renderFooter = () => {
  let config: EpicGamesFooterProps = {};
  if (root._epicGamesFooterObserver && root._epicGamesFooterObserver.subject) {
    config = root._epicGamesFooterObserver.subject;
  }

  const theme = root._epicGamesFooterTheme;

  const newsLetterConfigs = config.newsLetterConfigs || {};
  const enableNewsLetter =
    (config.enableNewsLetter && newsLetterConfigs.enableNewsLetterCMS) || false;

  render(
    <EmbeddedProvider serverURL={new URL(config.serverUrl)}>
      <EpicGamesFooter
        theme={theme}
        {...config}
        enableNewsLetter={enableNewsLetter}
        newsLetterConfigs={newsLetterConfigs}
        LinkComponent={EmbeddedNavLinkComponent}
      />
    </EmbeddedProvider>,

    root.document.getElementById('epicGamesFooter')
  );
};

addObserverCallback(renderFooter);
renderFooter();
